export interface PurchaseOrderPurchaseAllocation {
  id: string ;
  orderNo: string ;
  supplierKey: string ;
  supplierName: string ;
  productKey: string ;
  productDescription: string ;
  allocationType: string ;
  allocated: number ;
  deliveryDate: Date ;
}
